import gql from 'graphql-tag';

export const GET_APP_CONFIG_QUERY = gql`
  query GetAppConfig($blockId: String!) {
    getAppConfig(blockId: $blockId) {
      code
      httpStatus
      message
      details
      body {
        blockId
        config
      }
    }
  }
`;
